// extracted by mini-css-extract-plugin
export default {"heading":"NSpSx","paragraph":"WTNXS","main":"Vmph9","errorMessage":"kEY0V","face":"IbEux"};